import React from "react";

export default function TableBusyOverlay({ show = false, tone = "admin", className = "" }) {
  if (!show) return null;

  const isAdmin = tone === "admin";

  return (
    <div
      className={`absolute inset-0 z-10 flex items-center justify-center ${
        isAdmin ? "bg-white/80" : "bg-black/60"
      } ${className}`.trim()}
      role="status"
      aria-live="polite"
    >
      <p className={`text-sm font-semibold ${isAdmin ? "text-gray-800" : "text-white"}`}>
        Loading...
      </p>
    </div>
  );
}

export function BusyTable({ show = false, tone = "admin", children, className = "" }) {
  return (
    <div className="relative">
      <TableBusyOverlay show={show} tone={tone} />
      <div className={`${show ? "pointer-events-none opacity-50" : ""} ${className}`.trim()}>
        {children}
      </div>
    </div>
  );
}
